import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  accountUsageLock,
  subscriptionExpired,
} from '../../helpers/App';
import { userCan } from '../../helpers/Auth';
import { eventSubscribe, eventUnsubscribe } from '../../helpers/Events';
import { showModalTop } from '../../actions';

const DashboardWidgetUploadFile = ({ profile, openFileUploadedModal }) => {
  const intl = useIntl();

  const triggerInputFile = () => {
    if (!accountUsageLock(profile.client) && !subscriptionExpired(profile.client)) {
      document.getElementById('upload-file-input').click();
    }
  };

  const triggerInputFolder = () => {
    if (!accountUsageLock(profile.client) && !subscriptionExpired(profile.client)) {
      document.getElementById('upload-folder-input').click();
    }
  };

  const handleFilesUploaded = useCallback((event) => {
    openFileUploadedModal({
      fileCount: event.detail.filesCount,
      collection: event.detail.collection,
    });
  }, [openFileUploadedModal]);

  useEffect(() => {
    eventSubscribe('filesUploaded', handleFilesUploaded);

    return () => {
      eventUnsubscribe('filesUploaded', handleFilesUploaded);
    };
  }, [handleFilesUploaded]);

  if (!userCan('file.upload')) {
    return null;
  }

  return (
    <div className="widget widget-upload-file grid-item">
      <div className="grid-item-img-wrapper">
        <div className="grid-item-img">
          <i className="fal fa-upload" />
        </div>
      </div>
      <div className="grid-item-body">
        <h5>{intl.formatMessage({ defaultMessage: 'Upload files or folders' })}</h5>
        <div className="grid-item-details file-details" />
        <div className="grid-item-actions">
          <Button color="link" onClick={triggerInputFile}>
            <i className="far fa-file" />
            {intl.formatMessage({ defaultMessage: 'File' })}
          </Button>
          <Button color="link" onClick={triggerInputFolder}>
            <i className="far fa-folder" />
            {intl.formatMessage({ defaultMessage: 'Folder' })}
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

const mapDispatchToProps = dispatch => ({
  openFileUploadedModal: (params) => {
    dispatch(showModalTop('FileUploadedModal', params));
  },
});

DashboardWidgetUploadFile.propTypes = {
  openFileUploadedModal: PropTypes.func.isRequired,
  profile: PropTypes.object,
};

DashboardWidgetUploadFile.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardWidgetUploadFile);
